/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import messages from './RiskAssistDwellingsComponent.messages.js'
import metadata from './RiskAssistDwellingsComponent.metadata.json5';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from '../PropertyDetails/PropertyDetailsComponent';
import ConstructionComponent from '../Construction/ConstructionComponent';
import OilTankComponent from '../OilTank/OilTankComponent';
import UtilitiesComponent from '../Utilities/UtilitiesComponent';
import SolidFuelHeatingComponent from '../SolidFuelHeating/SolidFuelHeatingComponent';
import RentalsTenantsComponent from '../RentalsTenants/RentalsTenantsComponent.jsx';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RiskAssistDwellingsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();

    const viewModelService = useContext(ViewModelServiceContext);

    modelVM.value.isValidationReq = true;

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('RiskAssistDwellingsComponent');
    const vacantOccCode = ['VacCom', 'VacDwe', 'VacCon']


    const deleteRiskAssistDwellingDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    const overrideProps = {
        propertyDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.propertyDetails`,
            viewModelService
        },
        constructionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.construction`,
            propertyDetailsPath: `${pathUpdated}.propertyDetails`,
            dwellingPathUpdated: pathUpdated,
            viewModelService
        },
        utilitiesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.utilities`,
            viewModelService
        },
        oilTankComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.oilTank`,
            viewModelService,
            visible: (!_.isUndefined(_.get(submissionVM, `${pathUpdated}.utilities.priHeaFie.value`))
                && _.get(submissionVM, `${pathUpdated}.utilities.priHeaFie.value.code`) === 'OilFur')
                || (!_.isUndefined(_.get(submissionVM, `${pathUpdated}.utilities.priHeaFueTypFie.value`))
                    && _.get(submissionVM, `${pathUpdated}.utilities.priHeaFueTypFie.value.code`) === 'Oil')
                || (!_.isUndefined(_.get(submissionVM, `${pathUpdated}.utilities.auxHeaFie.value`))
                    && _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFie.value.code`) === 'OilHea')
                || (!_.isUndefined(_.get(submissionVM, `${pathUpdated}.utilities.auxHeaFueTypFie.value`))
                    && _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFueTypFie.value.code`) === 'Oil')
        },
        solidFuelHeatingComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.solidFuelHeating`,
            dwellingPathUpdated: pathUpdated,
            viewModelService,
            visible: (!_.isUndefined(_.get(submissionVM, `${pathUpdated}.utilities.priHeaFueTypFie.value`))
                && (_.get(submissionVM, `${pathUpdated}.utilities.priHeaFueTypFie.value.code`) === "Wood")
                || _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFueTypFie.value.code`) === "Wood"
                || _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFie.value.code`) === "FreStaWoo"
                || _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFie.value.code`) === "ZerCleAirTigIns"
                || _.get(submissionVM, `${pathUpdated}.utilities.auxHeaFie.value.code`) === "ComwitWoo")
                && (_.get(submissionVM, `${pathUpdated}.construction.isthestoFie.value`)
                    || _.get(submissionVM, `${pathUpdated}.construction.isthechiFie.value`)
                    || _.get(submissionVM, `${pathUpdated}.construction.isthefirFie.value`)
                    || _.get(submissionVM, `${pathUpdated}.construction.istheflupipFie.value`))
        },
        rentalsTenantsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.rentalsTenants`,
            dwellingPathUpdated: pathUpdated,
            viewModelService,
            visible: !_.isUndefined(_.get(submissionVM, `${pathUpdated}.propertyDetails.occFie.value.code`))
             && !vacantOccCode.includes(_.get(submissionVM, `${pathUpdated}.propertyDetails.occFie.value.code`))
        },
        riskAssistDwellingsAccordionDetails: {
            title: _.get(
                modelVM,
                `propertyDetails.accountLocFie.displayName.value`
            )
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteRiskAssistDwellingDetails
        },
        resolveComponentMap: {
            propertyDetailsComponent: PropertyDetailsComponent,
            constructionComponent: ConstructionComponent,
            utilitiesComponent: UtilitiesComponent,
            oilTankComponent: OilTankComponent,
            solidFuelHeatingComponent: SolidFuelHeatingComponent,
            rentalsTenantsComponent: RentalsTenantsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, submissionVM, id, path, overrideProps),
        [metadata.componentContent, submissionVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            onModelChange={updateWizardData}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            resolveValue={readValue}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.classNameMap}
        />
    );
}

RiskAssistDwellingsComponent.propTypes = wizardProps;
export default withRouter(RiskAssistDwellingsComponent);
